import React from 'react';
import { useNavigate } from 'react-router-dom';
import './style.css';

export default function BackButton({ toFallback = '/', label = 'Voltar' }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate(toFallback);
    }
  };

  return (
    <div className="back-button" onClick={handleBack}>
      <i className="bi bi-arrow-left-circle" role="button" />
      <span>{label}</span>
    </div>
  );
}
